import { Button, Group, Modal, Space, Text } from '@mantine/core';
import { IconCancel, IconCircleCheck } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { lightGreyIconButtonStyle } from '../theme/styling/buttonStyling';
import { defaultIconStyle } from '../theme/styling/iconStyling';
import { Title } from './Title';

export interface SmallModalProps {
	isOpen: boolean;
	withCloseButton?: boolean;
	close: () => void;
	onComplete?: () => void;
	title: ReactNode;
	body: ReactNode;
    cancelText?:  string;
    okText?:  string;
}

export function SmallModal({
	close,
	isOpen,
	onComplete,
    cancelText = "Cancel",
    okText = "Ok",
	title,
	body,
}: SmallModalProps) {
	return (
		<>
			<Modal
				opened={isOpen}
				onClose={close}
				title={<Title size={'1rem'} fw={500} label={title} />}
				centered
				padding={20}
				size={'md'}
			>
				<Text>{body}</Text>
				<Space h={20} />
				<Group justify={'flex-end'}>
					{onComplete ? (
						<>
							<Button
								{...lightGreyIconButtonStyle}
								onClick={() => close()}
								data-cy={'close-button'}
								leftSection={<IconCancel {...defaultIconStyle} />}
							>
                                {cancelText}
							</Button>
							<Button
								{...lightGreyIconButtonStyle}
								type={'submit'}
								leftSection={<IconCircleCheck {...defaultIconStyle} />}
								onClick={() => {
									onComplete ? onComplete() : close();
								}}
								data-cy={'submit-button'}
							>
                                {okText}
							</Button>
						</>
					) : (
						<Button
							{...lightGreyIconButtonStyle}
							leftSection={<IconCircleCheck {...defaultIconStyle} />}
							onClick={() => {
								close();
							}}
							data-cy="ok-button"
						>
                            {okText}
						</Button>
					)}
				</Group>
			</Modal>
		</>
	);
}
